import AttributeCookies from './AttributeCookies';


const createAttributeSelectorObject = (filteringAttributes = []) => {
  const attributeCookies = new AttributeCookies();

  if (!filteringAttributes) {
    return { displaySelector: false };
  }

  let displaySelector = false;
  let optionTitles = [];
  const formValues = {};
  let allowSelection = false;

  filteringAttributes.forEach(({ options, filter }, i) => {
    if (options.length > 1) {
      allowSelection = true;
    }

    if (options.length > 0) {
      displaySelector = true;
    }

    const activeFilter = attributeCookies.getChildValue(filter);
    let activeOption = options.find((option) => option.value == activeFilter)
      ?? options.find((option) => option.default);

    if (activeOption) {
      formValues[filter] = {
        value: activeOption.value,
        order: i,
      };
  
      optionTitles.push(activeOption.label);
    }
  });

  return {
    formValues,
    optionTitle: optionTitles.join(' '),
    displaySelector,
    filteringAttributes,
    allowSelection,
  };
};

export default createAttributeSelectorObject;
